import {isStaff} from '@github-ui/stats'
import {testIdProps} from '@github-ui/test-id-props'
import {Label, Link, ToggleSwitch} from '@primer/react'
import {useCallback} from 'react'

import {useAgentAssignmentVisibility} from '../../features/copilot-tasks/use-agent-assignment-visibility'
import {ViewerPrivileges} from '../../helpers/viewer-privileges'
import type {BaseViewState, ViewIsDirtyStates} from '../../hooks/use-view-state-reducer/types'
import {PotentiallyDirty} from '../potentially-dirty'
import styles from './hierarchy-toggle.module.css'

const STAFF_FEEDBACK_URL = 'https://github.com/github/planning-tracking/discussions/2618'
const PUBLIC_FEEDBACK_URL = 'https://github.com/orgs/community/discussions/190731'

export function AgentAssignmentToggle({view}: {view: BaseViewState & ViewIsDirtyStates}) {
  const {hasWritePermissions} = ViewerPrivileges()
  const {agentAssignmentVisible: visible, setAgentAssignmentVisible: setVisible} = useAgentAssignmentVisibility()

  const onClick = useCallback(() => {
    setVisible(view.number, !visible)
  }, [visible, setVisible, view.number])

  const feedbackUrl = isStaff() ? STAFF_FEEDBACK_URL : PUBLIC_FEEDBACK_URL

  return (
    <div className={styles.toggleContainer}>
      <div className="d-flex align-items-center gap-2">
        <PotentiallyDirty
          isDirty={view.isAgentAssignmentVisibleDirty}
          hideDirtyState={!hasWritePermissions}
          {...testIdProps('agent-assignment-dirty')}
        >
          <div id="agent-assignment-visible-label">Show agent sessions</div>
        </PotentiallyDirty>
        {feedbackUrl ? (
          <Link href={feedbackUrl} inline className={styles.betaLink}>
            <Label variant="success" className={styles.betaLabel}>
              Beta
            </Label>
          </Link>
        ) : (
          <Label variant="success">Beta</Label>
        )}
      </div>
      <ToggleSwitch size="small" aria-labelledby="agent-assignment-visible-label" checked={visible} onClick={onClick} />
    </div>
  )
}
